import { render } from "./App.vue?vue&type=template&id=67e0d1ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=67e0d1ba&lang=css"

import exportComponent from "/home/jenkins/workspace/大象新闻saas前台部署/大象新闻APP（prod）/抗疫H5 生产/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__